document.addEventListener('livewire:load', function () { // Component ready

    // Summer Note
    function registerSummernote(element, placeholder, max, callbackMax) {
        $(element).summernote({
            toolbar: [
                ['style', ['bold', 'italic']], //Specific toolbar display
                ['color', ['color']],
                ['para', ['paragraph']]
            ],
            placeholder,
            callbacks: {
                onKeydown: function(e) {
                    var t = e.currentTarget.innerText;
                    if (t.length >= max) {
                        //delete key
                        if (e.keyCode != 8)
                            e.preventDefault();
                        // add other keys ...
                    }
                },
                onKeyup: function(e) {
                    var t = e.currentTarget.innerText;
                    if (typeof callbackMax == 'function') {
                        callbackMax(max - t.length);
                    }
                },
                onPaste: function(e) {
                    var t = e.currentTarget.innerText;
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                    e.preventDefault();
                    var all = t + bufferText;
                    document.execCommand('insertText', false, all.trim().substring(0, 2000));
                    if (typeof callbackMax == 'function') {
                        callbackMax(max - t.length);
                    }
                },
                onChange: function(contents, $editable) {
                    Livewire.emit('orgStoryUpdated', contents);
                }
            }
        });
    }

    $(function(){
        registerSummernote(
            '.summernote-editor',
            'Tell us more about your organisation and how these funds will make a difference',
            2000,
            function(max) {
                $('#text-count').text(max)
            });
    });

}); // Component ready
